import classnames from 'classnames'

const Label = ({ children, size = 'extra-small', className = '' }) => (
    <span className={classnames('d-block', `text-${size}`, 'text-light', 'text-uppercase', className, 'mb-1')}>
        {children}
    </span>
)

Label.propTypes = {
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    size: PropTypes.oneOf(['extra-small', 'small', 'base', 'large', 'extra-large']),
    classnames: PropTypes.string,
}

export default Label
